const SvgIconLock = (props) => (
  <svg viewBox="0 0 14 18" fill="none" {...props}>
    <path
      d="M5.5 12a1.5 1.5 0 0 1 3 0c0 .553-.303 1.032-.75 1.292V15h-1.5v-1.708A1.494 1.494 0 0 1 5.5 12zm8.25-4.5V18H.25V7.5H2.5v-3a4.5 4.5 0 0 1 9 0v3h2.25zM4 7.5h6v-3c0-1.655-1.346-3-3-3s-3 1.345-3 3v3zM12.25 9H1.75v7.5h10.5V9z"
      fill="currentColor"
    />
  </svg>
)

export default SvgIconLock
